<template>
  <div class="app-shell">
    <div class="app-shell__inner page-wrap" :class="{ 'is-auth-layout': !showNavigation }">
      <DesktopSidebar v-if="showNavigation" :user="user" :current-club="currentClub" />
      <main class="app-shell__content" :class="{ 'has-mobile-nav': showNavigation }">
        <slot />
      </main>
    </div>
    <MobileNav v-if="showNavigation" />
  </div>
</template>

<script>
import DesktopSidebar from './DesktopSidebar.vue';
import MobileNav from './MobileNav.vue';

export default {
  name: 'AppShell',
  components: { DesktopSidebar, MobileNav },
  props: {
    showNavigation: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
    currentClub: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped src="./AppShell.css"></style>
